/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2017, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// eslint-disable-next-line no-undef
requirejs.config({
	paths: {
		// gemini should not be used in any require path. dashboard-core is the official root
		// Needed to reference the api and features : dashboard-core/api ,  dashboard-core/feature
		'dashboard-core/js' : 'js/gemini',
		'@dashboard-features' : 'js/dashboard-features',
		'dashboard-cdn': 'empty:',

		// Rave 1
		'com/ibm/vis' : 'lib/rave/1.8.0.12/rave/com/ibm/vis',

		// Rave 2
		'rave2' : 'lib/rave/2.0.0/rave.min',

		// Ace editor
		'ace' : 'lib/ace-builds/1.2.0',

		// Rave Current
		'rave-current' : 'lib/rave/current',
		'rave' : 'lib/rave/current/rave/rave',
		'rave-library' : 'lib/rave/current/rave-library/rave-library',
		'rave-legends' : 'lib/rave/current/rave-legends/rave-legends',
		'rave-layouts' : 'lib/rave/current/rave-layouts/rave-layouts',
		'rave-utilities' : 'lib/rave/current/rave-utilities/rave-utilities',
		'mapboxgl' : 'lib/rave/current/rave-library-tiledmap/mapbox-gl',
		'turf' : 'lib/rave/current/rave-library-tiledmap/turf.min',

		// Dojo (for Rave1)
		'dojo' : 'lib/rave/1.8.0.12/dojo',
		'dojox' : 'lib/rave/1.8.0.12/dojox',
		'rave/dojo': 'lib/rave/1.8.0.12/dojo',
		'authoring-common': 'js/authoring-common/bundles/authoring-common.min',
		'authoring-common-services': 'js/authoring-common/bundles/services.min',
		'authoring-common-bridges': 'js/authoring-common/bundles/bridges.min'
	},
	map: {
		'*': {
			'@waca/dashboard-core' : 'dashboard-core',
			'@waca/dashboard-common/js': 'dashboard-core/js/lib/@waca/dashboard-common/dist',
			'bi/content_apps/common/ContentSelectionDialogView': 'bacontentnav/common/ContentSelectionDialogView',

			'bi/conversion-service': 'js/gemini/lib/@waca/conversion-service/dist',

			// Temprorary until Explore and storytelling are fixed - layout extensions in explore are using the wrong path
			'dashboard-core/explore': 'explore',
			'dashboard-core/storytelling': 'storytelling',

			// We should never use /gemini in an require.js path.. but it still being used in some places
			'gemini' : 'dashboard-core/js',

			// The following paths are only here for backward compatibility
			// The right path to access the dashboard core js is /dashboard-core/js
			'app' : 'dashboard-core/js/app',
			'dashboard-app' : 'dashboard-core/js/app',
			'dashboard' : 'dashboard-core/js/dashboard',
			'pinning' : 'dashboard-core/js/pinning',
			'common' : 'dashboard-core/js/common',
			'dashboard-common' : 'dashboard-core/js/common',
			'lib/@waca': 'dashboard-core/js/lib/@waca',
			'@ba-ui-toolkit/ba-graphics': 'js/gemini/lib/@waca/dashboard-common/dist/lib/@ba-ui-toolkit/ba-graphics',

			//for exlore which still uses gemini
			'gemini/lib/@waca/baglass/js/baglass': 'baglass',
			'gemini/lib/@waca/core-client': 'baglass/core-client',

			'dashboard-core/js/lib/@waca/baglass/js/baglass': 'baglass',
			'dashboard-core/js/lib/@waca/core-client': 'baglass/core-client',
			'dashboard-core/js/lib/@waca/bacontentnav/public/js/bacontentnav/lib/@waca/baglass/js/baglass' : 'baglass',
			'dashboard-core/js/lib/@waca/bacontentnav/public/js/bacontentnav/lib/@waca/core-client' : 'baglass/core-client',
			'dashboard-core/js/lib/@waca/dashboard-common/dist/lib/@waca/baglass/js/baglass': 'baglass',
			'dashboard-core/js/lib/@waca/dashboard-common/dist/lib/@waca/core-client': 'baglass/core-client'
		}
	},
	bundles: {
		// Need so we can reference a webpack bundle from a perspective file
		'authoring-common-bridges': [
			'authoring-common/paletteService',
			'authoring-common/changePaletteView'
		],
		'authoring-common-services': []
	}
});
